// import { myAxios } from "./Helper";
// import { setToken } from './tokenService';

// export const signUp = async (user) => {
//     try {
//         const response = await myAxios.post("api/user/auth/register/user", user);
//         return response.data;
//     } catch (error) {
//         console.error('Error during sign up:', error.message);
//         throw error;
//     }
// };

// export const login = (credentials) => {
//     return myAxios.post("api/user/auth/login", credentials)
//         .then((response) => {
//             if (response.status !== 200) {
//                 throw new Error('Login failed');
//             }
//             const { token, role, id, firstName } = response.data;
//             setToken(token);
//             localStorage.setItem('userRole', role);
//             return { role, id, firstName };
//         });
// };


// // Correct the API endpoints in user-service.js
// export const forgotPassword = (email) => {
//     return myAxios.post('/api/forgotpassword/forgot-password', { email });
// };

// export const resetPassword = (data) => {
//     return myAxios.post('/api/forgotpassword/verifyOtp', {
//         email: data.email,
//         otp: data.code,
//         newPassword: data.newPassword
//     });
// };















import { myAxios } from "./Helper";
import { setToken } from './tokenService';

export const signUp = async (user) => {
    try {
        const response = await myAxios.post("api/user/auth/register/user", user);
        return response.data;
    } catch (error) {
        console.error('Error during sign up:', error.message);
        throw error;
    }
};

// In your login function in user-service.js:
export const login = (credentials) => {
    return myAxios.post("api/user/auth/login", credentials)
        .then((response) => {
            if (response.status !== 200) {
                throw new Error('Login failed');
            }
            const { token, role, id, firstName } = response.data;
            setToken(token);
            localStorage.setItem('userRole', role);
            localStorage.setItem('userId', id); // Store userId consistently
            return { role, id, firstName };
        });
};


// Correct the API endpoints in user-service.js
export const forgotPassword = (email) => {
    return myAxios.post('/api/forgotpassword/forgot-password', { email });
};

export const resetPassword = (data) => {
    return myAxios.post('/api/forgotpassword/verifyOtp', {
        email: data.email,
        otp: data.code,
        newPassword: data.newPassword
    });
};